import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import './PaymentResult.css';
import tickCircleIcon from '../../assets/images/tickCircleIcon.svg';
import logoImage from '../../assets/images/newlogo.png';
import { MobilePlanService } from '../../Network/services/MobilePlanService';

const MobilePaymentResult = ({ dispatch }) => {
  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState('processing');
  const [orderDetails, setOrderDetails] = useState(null);
  const [paymentData, setPaymentData] = useState({
    orderDetails: null,
    amount: '',
    orderNote: ''
  });
  const getPlanType = (planData) => {
    if (!planData) return 'lite-plan';
    
    if (planData.is_premium === "0" || planData.is_premium === 0) {
      return 'lite-plan';
    } else if (planData.is_premium === "1" || planData.is_premium === 1) {
      return 'premium-plan';
    }
    return 'lite-plan';
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    const order_id = urlParams.get('order_id');
    setOrderDetails(order_id);
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
    verifyPayment(order_id);
  }, []);

  const verifyPayment = async (order_id) => {
    try {
      setIsLoading(true);
      
      if (!order_id) {
        setPaymentStatus('failed');
        return;
      }
      
      const response = await MobilePlanService.verifyMobilePayment(order_id);
      
      let orderData = response?.data;
      if (orderData?.data) {
        orderData = orderData.data;
      }
      
      const isStatus200 = response?.status === 200 || 
                         response?.status === "200" || 
                         orderData?.status === "200" || 
                         orderData?.status === 200;
      
      if (isStatus200 && orderData) {
        const orderStatus = orderData.order_status;
        const userPlan = orderData.user_plans?.[0];
        const paymentStatus = userPlan?.payment_status;
        
        if (orderStatus === "PAID" || paymentStatus === "completed") {
          setPaymentStatus('success');
          setPaymentData({
            orderDetails: orderData, 
            amount: `₹${orderData.order_amount}`,
            orderNote: orderData.order_note
          });
        } 
        else if (orderStatus === "ACTIVE" && paymentStatus === "failed") {
          setPaymentStatus('failed');
          setPaymentData({
            orderDetails: orderData,
            amount: `₹${orderData.order_amount}`,
            orderNote: orderData.order_note
          });
        } 
        else {
          setPaymentStatus('failed');
        }
      } else {
        setPaymentStatus('failed');
      }
    } catch (error) {
      setPaymentStatus('failed');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRetry = () => {
    const authToken = localStorage.getItem('authToken');
    history.push('/mobile/redirect-plans?authToken=' + authToken);
  };

  const handlePostJob = () => {
    localStorage.removeItem('authToken');
    const order_id = orderDetails;
    const deepLink = `gigfws://post-job?orderId=${order_id}`;
    window.location.href = deepLink;
  };

  if (isLoading) {
    return (
      <div className="payment-processing-container">
        <div className="processing-card">
          <div className="logo-container">
            <div className="fws-logo">
              <img src={logoImage} alt="FWS Logo" className="logo-image" />
            </div>
          </div>
          <h2 className="processing-title">Processing Your Payment</h2>
          <p className="processing-description">Please hold on while we securely process your payment.</p>
          <div className="redirect-message">Loading in few Seconds...</div>
        </div>
      </div>
    );
  }

  if (paymentStatus === 'success') {
    return (
      <div className="payment-result-container">
        <div className="result-card success-card">
          <div className="status-icon success-icon">
            <img src="/assets/images/PaymentSuccessfulIcon.svg" alt="Payment Successful" className="payment-icon" />
          </div>
          
          <h2 className="main-title">Plan Purchased Successfully 🎉</h2>
          <p className="confirmation-text">A confirmation email has been sent to your registered email address.</p>
          
          <div className={`plan-tag ${getPlanType(paymentData.orderDetails?.subscription_details?.[0])}`}>
            {paymentData.orderDetails?.subscription_details?.[0]?.subscription_name || 'GigFWS Lite'}
          </div>
          <div className="purchase-date">
            Purchased on {paymentData.orderDetails?.created_at ? 
              new Date(paymentData.orderDetails.created_at).toLocaleDateString('en-GB') : 
              new Date().toLocaleDateString('en-GB')
            }
          </div>
          
          <div className="plan-features">
            {paymentData.orderDetails?.subscription_details?.[0]?.content ? (
              paymentData.orderDetails.subscription_details[0].content.map((feature, index) => (
                <div key={index} className="feature-item">
                  <img src={tickCircleIcon} alt="check" className="feature-check" />
                  <span className="feature-text">{feature}</span>
                </div>
              ))
            ) : (
              // Fallback to static features if no content available
              <>
                <div className="feature-item">
                  <img src={tickCircleIcon} alt="check" className="feature-check" />
                  <span className="feature-text">Direct access to all job applicants and contacts with identity verification</span>
                </div>
                <div className="feature-item">
                  <img src={tickCircleIcon} alt="check" className="feature-check" />
                  <span className="feature-text">Access upto 6 months</span>
                </div>
                <div className="feature-item">
                  <img src={tickCircleIcon} alt="check" className="feature-check" />
                  <span className="feature-text">100% money back, if no job applicant found</span>
                </div>
              </>
            )}
          </div>
          
          <div className="button-group">
            <button className="use-plan-btn" onClick={handlePostJob}>
              Use Plan
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (paymentStatus === 'failed') {
    return (
      <div className="payment-result-container">
        <div className="result-card error-card">
          <div className="status-icon error-icon">
            <img src="/assets/images/PaymentFailedIcon.svg" alt="Payment Failed" className="payment-icon" />
          </div>
          
          <h2 className="main-title">Payment Failed</h2>
          <p className="confirmation-text">There was an error processing your payment. Please try again.</p>
          
          <div className={`plan-tag ${getPlanType(paymentData.orderDetails?.subscription_details?.[0])}`}>
            {paymentData.orderDetails?.subscription_details?.[0]?.subscription_name || 'GigFWS Premium'}
          </div>
          <div className="purchase-date">
            Attempted on {paymentData.orderDetails?.created_at ? 
              new Date(paymentData.orderDetails.created_at).toLocaleDateString('en-GB') : 
              new Date().toLocaleDateString('en-GB')
            }
          </div>
                
          <button className="retry-purchase-btn" onClick={handleRetry}>
            Retry Purchase
          </button>
        </div>
      </div>
    );
  }

  return null;
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(MobilePaymentResult);
